import styles from "./styles.module.scss";
import { RightWave, LeftWave } from "../../../../icons";

export const RevenueCard = ({ data }) => {
  const { title, bgColor, Icon, value, currency } = data || {};
  return (
    <div className={styles.cardContainer} style={{ backgroundColor: bgColor }}>
      <div className={styles.firstColumn}>
        <div className={styles.title}>{title}</div>
        <div className={styles.value}>
          <span>{currency}</span>
          {value}
        </div>
      </div>
      <div className={styles.icon}>
        <Icon />
      </div>
      <LeftWave className={styles.rightWave} />
      <RightWave className={styles.leftWave} />
    </div>
  );
};
